import PropTypes from 'prop-types';
import React from 'react';

import { isColorDark } from '../../lib/ArtUtils';
import colors from '../../sass/definitions/_colors.scss';

import './BlurredBackground.scss';

class BlurredBackground extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    height: PropTypes.number,
    backgroundType: PropTypes.oneOf(['solid', 'img', 'linearGradient']),
  };

  render() {
    const { backgroundColor, height, backgroundType } = this.props;
    const tintColor = isColorDark(backgroundColor) ? '#000' : '#fff';

    return (
      <div className='BlurredBackground' style={{ height }}>
        <svg className='BlurredBackground__svg'>
          <defs>
            <filter id='svg-blur-filter'>
              <feGaussianBlur stdDeviation='60' />
            </filter>
            <linearGradient id='linearGradient' x2='0' y2='1'>
              <stop offset='0%' stopColor={colors.colorCyan} />
              <stop offset='50%' stopColor={colors.colorBlueElectric} />
              <stop offset='100%' stopColor={colors.colorBlueElectric} />
            </linearGradient>
          </defs>
          {backgroundType === 'solid' && (
            <rect width='100%' height='100%' opacity='1' fill={backgroundColor} />
          )}
          {backgroundType === 'img' && (
            <React.Fragment>
              <rect width='100%' height='100%' opacity='1' fill={backgroundColor} />
              <image
                className='BlurredBackground__svg__image'
                preserveAspectRatio='xMinYMid slice'
                width='100%'
                height='100%'
                opacity='.2'
                filter='url(#svg-blur-filter)'
                xlinkHref={this.props.backgroundImage}
              />
              <rect width='100%' height='100%' opacity='.1' fill={tintColor} />
            </React.Fragment>
          )}
          {backgroundType === 'linearGradient' && (
            <rect width='100%' height='100%' opacity='1' fill='url(#linearGradient)' />
          )}
        </svg>
      </div>
    );
  }
}

export default BlurredBackground;
